import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useApi, useDirect } from "../../hooks";
import { getToast } from "../../common/utils";
import axios from "axios";
import keyNames from "../../keyName";
const ModalContent = ({ handleClose, dialogData }) => {
  const hitApi = useApi();
  const { widgetName, content } = dialogData;

  const toast = getToast("success");
  toast.description = "Deleted successfully!";
  const directDispatch = useDirect();

  // const handleDelete = (id) => {
  //   const toast = getToast();
  //   hitApi (
  //     `${apiCasestudy}/${id}`,
  //     null,
  //     method.delete,
  //     keyNames.caseStudyData,
  //     toast,
  //     {
  //       type: "delete",
  //     }
  //   );

  // };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `https://api.kestoneglobal.com/api/caseStudy/${id}`
      );

      if (response.data.status === "success") {
        handleClose();
        window.location.reload();
      } else {
        console.error("Unexpected response:", response.data);
        //const toast = getToast();
        // toast.error("Delete failed");
        handleClose();
        window.location.reload();
        directDispatch(toast, keyNames.toastData);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      const toast = getToast();
      //toast.error("Delete failed");
      directDispatch(toast, keyNames.toastData);
    }
  };

  return (
    <>
      <IconButton
        aria-label="close"
        className="customModalClose"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ minWidth: "40vw" }}>
        {content?.title && (
          <Typography variant="h6" component="div" align="center">
            {content.title}
          </Typography>
        )}
        {content?.description && (
          <DialogContentText align="center" mb={2}>
            {content.description}
          </DialogContentText>
        )}

        {content?.action && (
          <DialogActions className="flex justify-center gap-4">
            <Button variant="outlined" color="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDelete(content?.id)}
            >
              {content.action}
            </Button>
          </DialogActions>
        )}
      </DialogContent>
    </>
  );
};

export default ModalContent;
